import styles from './overall-spinner.module.scss';
import React, { PropsWithChildren } from 'react';
import { Spinner } from 'src/component/util/spinner';

export const OverallSpinner = (props: PropsWithChildren<{ isDisplayed?: boolean }>): React.ReactElement => {
	const { children, isDisplayed = false } = props;

	return (
		<div className={styles.container}>
			{children}
			<div className={`${styles.spinnerContainer} ${isDisplayed ? '' : styles.hide}`}>
				<Spinner className={styles.center} />
			</div>
		</div>
	);
};
